module.exports = __webpack_public_path__ + "img/07_Trennseite_Flächenbündig@2x.f1b0fc40.jpg";